import Vue from 'vue'
import Router from 'vue-router'
import Index from '@/components/index'
import Main from '@/components/page/main'
import News from '@/components/page/news'
import Product from '@/components/page/product'
import Server from '@/components/page/server'
import About from '@/components/page/about'
import ServerDetail from '@/components/page/server-detail'
import NewsDetail from '@/components/page/news-detail'
import ProductDetail from '@/components/page/product-detail'
import Plan from '@/components/page/plan'
import PlanDetail from '@/components/page/plan-detail'


Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/', redirect: '/index' ,meta: {requiresAuth: false}
    },
    {
      path: '/index', component: Index, children: [
        {path:'/index',component: Main},
        {path:'/product/:id',name:'product',component: Product},
        {path:'/product-detail/:id',name:'product-detail',component: ProductDetail},
        {path:'/news',component: News},
        {path:'/news/:id',name:'news-detail',component: NewsDetail},
        {path:'/server',component: Server},
        {path:'/about',component: About},
        {path:'/server-detail/:id',name:'server-detail',component: ServerDetail},
        {path:'/plan',component: Plan},
        {path:'/plan-detail/:id',name:'plan-detail',component: PlanDetail},
      ]
    }
  ]
})

const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err);
};



// WEBPACK FOOTER //
// ./src/router/index.js